import { ELoginActions,LoginActions } from '../actions/login.actions';
import { ILoginState, initialLoginState } from '../state/login.state';

export const loginReducers = (
  state = initialLoginState,
  action: LoginActions
): ILoginState => {
  switch (action.type) {
    case ELoginActions.LoginUsersSuccess: {
      return {
        ...state,
        currentLogin: action.payload
      };
    }
    default:
      return state;
  }
};
